import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import monitoringSlices, { type MonitoringSlices } from './slices';

const devtoolsInstance = devtools(monitoringSlices, {
  name: 'useMonitoringStore',
});

const useMonitoringStore = create<MonitoringSlices, [['zustand/devtools', never]]>(devtoolsInstance);

export default useMonitoringStore;
